import React, { useState } from 'react'
import { Container, Row, Col, Tab } from 'react-bootstrap'
import ButtonGroup from '@components/common/ButtonGroup/ButtonGroup.component'
import TrackerColumn from '../../components/pages/PatientStatusTracker/TrackerColumn.component'
import TrackerTable from '../../components/pages/PatientStatusTracker/TrackerTable.component'
import '../../components/pages/PatientStatusTracker/PatientStatusTracker.css'
import trackerData from '../../assets/mockdata/PatientTracker/trackerData.json'
import { StatusTypes } from '@components/common/StatusBadge/StatusBadge.component'
import PatientUpdates from '@components/pages/PatientStatusTracker/PatientUpdates.component'

const defaultColumns = [
  {
    id: 'scheduled',
    title: 'Scheduled',
    count: 0,
    bgColorClass: 'bg-scheduled',
    timeDuration: undefined,
    patientName: undefined,
    providerName: undefined,
    status: undefined,
  },
  {
    id: 'checked-in',
    title: 'Checked-in',
    count: 0,
    bgColorClass: 'bg-checked-in',
    timeDuration: undefined,
    patientName: undefined,
    providerName: undefined,
    status: undefined,
  },
  {
    id: 'in-treatment',
    title: 'In Treatment',
    count: 0,
    bgColorClass: 'bg-in-treatment',
    timeDuration: undefined,
    patientName: undefined,
    providerName: undefined,
    status: undefined,
  },
  {
    id: 'discharged',
    title: 'Discharged',
    count: 0,
    bgColorClass: 'bg-discharged',
    timeDuration: undefined,
    patientName: undefined,
    providerName: undefined,
    status: undefined,
  },
]

const PatientStatusTracker: React.FC = (): JSX.Element => {
  const [activeTab, setActiveTab] = useState<string>('tracker')
  const [viewMode, setViewMode] = useState<string>('column')

  const handleTabChange = (tabKey: string | null): void => {
    if (tabKey) {
      setActiveTab(tabKey)
    }
  }

  const toggleView = (mode: string): void => {
    setViewMode(mode)
  }

  const mappedTrackerData = defaultColumns.map((defaultColumn) => {
    const matchingTracker = trackerData.find(
      (tracker) => tracker.title === defaultColumn.title,
    )

    if (matchingTracker) {
      return {
        ...defaultColumn,
        ...matchingTracker,
        status:
          StatusTypes[matchingTracker.status as keyof typeof StatusTypes] ||
          undefined,
      }
    }

    return defaultColumn
  })

  const buttonData = [
    { label: 'Tracker', value: 'tracker' },
    { label: 'Updates', value: 'updates' },
  ]

  const viewButtonData = [
    { label: 'Column', value: 'column', icon: 'ti ti-columns-3' },
    { label: 'Table', value: 'table', icon: 'ti ti-table' },
  ]

  return (
    <Container fluid className="p-0">
      <Tab.Container activeKey={activeTab} onSelect={handleTabChange}>
        <Row className="my-2 mx-0">
          <Col className="d-flex justify-content-between align-items-center">
            <div className="d-flex">
              <ButtonGroup
                buttons={buttonData}
                activeTab={activeTab}
                onButtonClick={handleTabChange}
                className="nb-handle tracker-button-group ms-0 mb-1"
              />
            </div>
            {activeTab === 'tracker' && (
              <div className="d-flex column-switch">
                <ButtonGroup
                  buttons={viewButtonData}
                  activeTab={viewMode}
                  onButtonClick={toggleView}
                  className="nb-handle tracker-button-group"
                />
              </div>
            )}
          </Col>
        </Row>

        <Row className="my-2 mx-0">
          <Col>
            <Tab.Content>
              <Tab.Pane eventKey="tracker">
                {viewMode === 'column' ? (
                  <Row className="g-2 vh-100">
                    {mappedTrackerData.map((tracker) => (
                      <TrackerColumn
                        key={tracker.id}
                        title={tracker.title}
                        count={tracker.count}
                        bgColorClass={tracker.bgColorClass}
                        timeDuration={tracker.timeDuration}
                        patientName={tracker.patientName}
                        status={tracker.status}
                        providerName={tracker.providerName}
                      />
                    ))}
                  </Row>
                ) : (
                  <TrackerTable trackerData={mappedTrackerData} />
                )}
              </Tab.Pane>
              <Tab.Pane eventKey="updates">
                <PatientUpdates />
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </Container>
  )
}

export default PatientStatusTracker
